import type { IconDecorationProtocol } from '@lighthouse/core'
import React from 'react'

import { IconRender } from '../IconPicker'
import { PauseIcon, PlayIcon, VoiceWaveIcon } from './icons'

export type AudioPlayingFallback = 'pause' | 'wave'

interface AudioStatusIconProps {
    playing: boolean
    icon?: IconDecorationProtocol
    color?: string
    size?: number
    playingFallback?: AudioPlayingFallback
    waveFrame?: 0 | 1 | 2
    onGetFullUrl?: (url: string) => string
}

export const AudioStatusIcon: React.FC<AudioStatusIconProps> = ({
    playing,
    icon,
    color = 'currentColor',
    size = 14,
    playingFallback = 'pause',
    waveFrame = 0,
    onGetFullUrl
}) => {
    if (icon?.value) {
        return <IconRender isCompact readonly value={icon} color={color} size={size} onGetFullUrl={onGetFullUrl} />
    }
    if (playing) {
        if (playingFallback === 'wave') {
            return <VoiceWaveIcon frame={waveFrame} size={size} color={color} />
        }
        return <PauseIcon size={size} color={color} />
    }
    return <PlayIcon size={size} color={color} />
}
